"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateContactCommunicationDetailsDto = exports.IsValidCommunicationDetails = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
const class_validator_2 = require("class-validator");
// Custom validator to ensure communicationDetails is valid based on communicationType
let IsValidCommunicationDetails = class IsValidCommunicationDetails {
    validate(value, args) {
        // If value is null or undefined, let @IsNotEmpty handle the validation
        if (value == null) {
            return true;
        }
        const object = args.object;
        if (object.communicationType === "email") {
            // Validate email format
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        }
        else if (object.communicationType === "phone") {
            // Validate phone format (10-digit number)
            return /^[0-9]{10}$/.test(value);
        }
        return false; // Invalid if communicationType is neither "email" nor "phone"
    }
    defaultMessage(args) {
        const object = args.object;
        if (object.communicationType === "email") {
            return `communicationDetails must be a valid email address.`;
        }
        else if (object.communicationType === "phone") {
            return `communicationDetails must be a valid 10-digit phone number.`;
        }
        return `communicationType must be either 'email' or 'phone'.`;
    }
};
exports.IsValidCommunicationDetails = IsValidCommunicationDetails;
exports.IsValidCommunicationDetails = IsValidCommunicationDetails = tslib_1.__decorate([
    (0, class_validator_2.ValidatorConstraint)({ name: "IsValidCommunicationDetails", async: false })
], IsValidCommunicationDetails);
class CreateContactCommunicationDetailsDto {
}
exports.CreateContactCommunicationDetailsDto = CreateContactCommunicationDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Type of communication (email or phone)",
        example: "email",
        required: true,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Communication type is required." }),
    (0, class_validator_1.IsString)({ message: "Communication type must be a string." }),
    (0, class_validator_1.IsIn)(["email", "phone"], {
        message: "Communication type must be 'email' or 'phone'.",
    }),
    tslib_1.__metadata("design:type", String)
], CreateContactCommunicationDetailsDto.prototype, "communicationType", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Details of the communication (email address or phone number)",
        example: "john.doe@example.com",
        required: true,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Communication details are required." }),
    (0, class_validator_1.IsString)({ message: "Communication details must be a string." }),
    (0, class_validator_1.Validate)(IsValidCommunicationDetails),
    tslib_1.__metadata("design:type", String)
], CreateContactCommunicationDetailsDto.prototype, "communicationDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Indicates if this is the primary communication detail",
        example: false,
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)({ message: "isPrimary must be a boolean value." }),
    tslib_1.__metadata("design:type", Boolean)
], CreateContactCommunicationDetailsDto.prototype, "isPrimary", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Contact ID associated with the contact details",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Contact ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateContactCommunicationDetailsDto.prototype, "contact", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "User who created the record",
        example: "admin",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Created by must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateContactCommunicationDetailsDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "User who last updated the record",
        example: "admin",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Updated by must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateContactCommunicationDetailsDto.prototype, "updatedBy", void 0);
